import React, { useState, useEffect, useCallback } from 'react';

function Lightbox({ images, alts = [], initialIndex = 0, onClose }) {
    const [current, setCurrent] = useState(initialIndex);

    const prev = useCallback(() =>
        setCurrent(c => (c - 1 + images.length) % images.length), [images.length]);
    const next = useCallback(() =>
        setCurrent(c => (c + 1) % images.length), [images.length]);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape')     onClose();
            if (e.key === 'ArrowLeft')  prev();
            if (e.key === 'ArrowRight') next();
        };
        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [onClose, prev, next]);

    return (
        <div className="lb-overlay" onClick={onClose}>
            <button className="lb-close" onClick={onClose} aria-label="Chiudi">✕</button>

            {images.length > 1 && (
                <>
                    <button
                        className="lb-arrow lb-prev"
                        onClick={e => { e.stopPropagation(); prev(); }}
                        aria-label="Precedente"
                    >
                        ‹
                    </button>
                    <button
                        className="lb-arrow lb-next"
                        onClick={e => { e.stopPropagation(); next(); }}
                        aria-label="Successiva"
                    >
                        ›
                    </button>
                </>
            )}

            <div className="lb-box" onClick={e => e.stopPropagation()}>
                <img
                    src={images[current]}
                    alt={alts[current] || `Foto ${current + 1}`}
                    className="lb-img"
                />
            </div>

            {images.length > 1 && (
                <div className="lb-counter">{current + 1} / {images.length}</div>
            )}
        </div>
    );
}

export default Lightbox;
